// src/context/LanguageContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();
export const useLanguage = () => useContext(LanguageContext);

export function LanguageProvider({ children }) {
  // Default to Portuguese
  const [language, setLanguage] = useState(() => {
    // Try to get from localStorage, default to 'pt'
    return localStorage.getItem("appLanguage") || "pt";
  });

  // Save to localStorage whenever language changes
  useEffect(() => {
    localStorage.setItem("appLanguage", language);
  }, [language]);

  const toggleLanguage = (lang) => {
    console.log("LanguageContext: Setting language to", lang);
    setLanguage(lang);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage: toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}
